var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2721 24.2722L29.6861 25.6862C32.6867 22.6854 36.7565 20.9996 41.0001 20.9996C45.2437 20.9996 49.3135 22.6854 52.3141 25.6862L53.7281 24.2722C50.3525 20.8965 45.7741 19 41.0001 19C36.2262 19 31.6478 20.8965 28.2721 24.2722Z",
    fill: "#A4379E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9996 26.9999C38.3467 26.9964 35.8019 28.0505 33.9286 29.9289L35.3426 31.3429C36.8429 29.8425 38.8778 28.9996 40.9996 28.9996C43.1214 28.9996 45.1563 29.8425 46.6566 31.3429L48.0706 29.9289C46.1972 28.0505 43.6524 26.9964 40.9996 26.9999Z",
    fill: "#A4379E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9999 54.9999V51.7209L45.6839 50.9479C45.4185 50.8589 45.2026 50.6628 45.0885 50.4072C44.9745 50.1515 44.9728 49.8598 45.0839 49.6029L47.9999 42.8729V40.9999C47.987 37.0205 49.8032 33.2558 52.926 30.7892C56.0488 28.3226 60.1317 27.4277 63.9999 28.3619V63.9999H55.9999V58.9999H51.9999C49.7908 58.9999 47.9999 57.209 47.9999 54.9999Z",
    fill: "#A4379E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 55V51.721L36.316 50.948C36.5814 50.859 36.7973 50.6629 36.9114 50.4073C37.0254 50.1516 37.0271 49.8599 36.916 49.603L34 42.873V41C34 33.8203 28.1797 28 21 28C19.9893 28.0038 18.9826 28.1253 18 28.362V64H26V59H30C32.2091 59 34 57.2091 34 55Z",
    fill: "#A4379E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9997 39C42.1043 39 42.9997 38.1046 42.9997 37C42.9997 35.8954 42.1043 35 40.9997 35C39.8952 35 38.9997 35.8954 38.9997 37C38.9997 38.1046 39.8952 39 40.9997 39Z",
    fill: "#A4379E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeers);
export default __webpack_public_path__ + "static/media/peers.9aaf31218fc8018062d514b09c33f3e0.svg";
export { ForwardRef as ReactComponent };